<template>
  <p class="tw-font-bold tw-leading-snug tw-text-neutral-900 tw-text-xl">
    <slot />
  </p>
</template>
